/**
 * GENERATED CODE – DO NOT EDIT!
 */
/* eslint-disable */
import * as $protobuf from 'protobufjs/light';
import { fixType } from '../../../Fixes';
import Builder from '../../../Builder';
import '../../common/time';
import '../../connect/v2/common/money';
const $root = $protobuf.roots['default'] || ($protobuf.roots['default'] = new $protobuf.Root());
const jsonData = {
  "squareup": {
    "nested": {
      "corporate_card": {
        "nested": {
          "resources": {
            "nested": {
              "CreditLimitAdjustment": {
                "fields": {
                  "identifier": {
                    "type": "string",
                    "id": 1,
                    "rule": "optional"
                  },
                  "hasBeenAcknowledgedInFrontend": {
                    "type": "bool",
                    "id": 3,
                    "rule": "optional"
                  },
                  "effectiveDate": {
                    "type": "squareup.common.time.DateTime",
                    "id": 4,
                    "rule": "optional"
                  },
                  "adjustedTo": {
                    "type": "squareup.connect.v2.common.Money",
                    "id": 5,
                    "rule": "optional"
                  },
                  "adjustedFrom": {
                    "type": "squareup.connect.v2.common.Money",
                    "id": 6,
                    "rule": "optional"
                  },
                  "decrease": {
                    "type": "squareup.corporate_card.resources.CreditLimitAdjustment.Decrease",
                    "id": 2
                  },
                  "increase": {
                    "type": "squareup.corporate_card.resources.CreditLimitAdjustment.Increase",
                    "id": 7
                  }
                },
                "nested": {
                  "Decrease": {
                    "fields": {
                      "reason": {
                        "type": "squareup.corporate_card.resources.CreditLimitAdjustment.Decrease.DecreaseReason",
                        "id": 1,
                        "rule": "optional"
                      }
                    },
                    "nested": {
                      "DecreaseReason": {
                        "values": {
                          "CREDIT_LIMIT_DECREASE_REASON_UNKNOWN": 0,
                          "CREDIT_LIMIT_DECREASE_REASON_AUTOMATED_BY_CLM_SERVICE": 1
                        }
                      }
                    }
                  },
                  "Increase": {
                    "fields": {
                      "reason": {
                        "type": "squareup.corporate_card.resources.CreditLimitAdjustment.Increase.IncreaseReason",
                        "id": 1,
                        "rule": "optional"
                      },
                      "acceptanceType": {
                        "type": "squareup.corporate_card.resources.CreditLimitAdjustment.Increase.AcceptanceType",
                        "id": 2,
                        "rule": "optional"
                      }
                    },
                    "nested": {
                      "IncreaseReason": {
                        "values": {
                          "CREDIT_LIMIT_INCREASE_REASON_UNKNOWN": 0,
                          "CREDIT_LIMIT_INCREASE_REASON_AUTOMATED_BY_CLM_SERVICE": 1
                        }
                      },
                      "AcceptanceType": {
                        "values": {
                          "ACCEPTANCE_TYPE_UNKNOWN": 0,
                          "MANUALLY_ACCEPTED": 1,
                          "AUTOMATICALLY_ACCEPTED": 2
                        }
                      }
                    }
                  },
                  "Type": {
                    "oneof": ["decrease", "increase"]
                  }
                }
              }
            }
          }
        }
      }
    }
  }
};

// Do not initialize these protos if they have already been defined
if (!$root.nested?.squareup?.nested?.corporate_card?.nested?.resources?.nested?.CreditLimitAdjustment && !$root.nested?.squareup?.nested?.corporate_card?.nested?.resources?.nested?.CreditLimitAdjustment?.nested?.Decrease && !$root.nested?.squareup?.nested?.corporate_card?.nested?.resources?.nested?.CreditLimitAdjustment?.nested?.Decrease?.nested?.DecreaseReason && !$root.nested?.squareup?.nested?.corporate_card?.nested?.resources?.nested?.CreditLimitAdjustment?.nested?.Increase && !$root.nested?.squareup?.nested?.corporate_card?.nested?.resources?.nested?.CreditLimitAdjustment?.nested?.Increase?.nested?.IncreaseReason && !$root.nested?.squareup?.nested?.corporate_card?.nested?.resources?.nested?.CreditLimitAdjustment?.nested?.Increase?.nested?.AcceptanceType) {
  $root.addJSON(jsonData);
}

/**
 * SOURCE CreditLimitAdjustment @ squareup/corporate_card/resources/credit_limit_adjustment.proto at 9:1
 */
export const CreditLimitAdjustment = $root.lookupType('squareup.corporate_card.resources.CreditLimitAdjustment');
fixType(CreditLimitAdjustment, {
  identifier: {
    required: true
  },
  hasBeenAcknowledgedInFrontend: {
    required: true
  },
  effectiveDate: {
    required: true
  },
  adjustedTo: {
    required: true
  },
  adjustedFrom: {
    required: true
  }
});
Builder.createAndAttachToType(CreditLimitAdjustment);
/**
 * SOURCE Decrease @ squareup/corporate_card/resources/credit_limit_adjustment.proto at 10:3
 */
CreditLimitAdjustment.Decrease = $root.lookupType('squareup.corporate_card.resources.CreditLimitAdjustment.Decrease');
fixType(CreditLimitAdjustment.Decrease, {
  reason: {
    required: true
  }
});
Builder.createAndAttachToType(CreditLimitAdjustment.Decrease);
/**
 * SOURCE DecreaseReason @ squareup/corporate_card/resources/credit_limit_adjustment.proto at 13:5
 */
CreditLimitAdjustment.Decrease.DecreaseReason = $root.lookupEnum('squareup.corporate_card.resources.CreditLimitAdjustment.Decrease.DecreaseReason').values;
/**
 * SOURCE Increase @ squareup/corporate_card/resources/credit_limit_adjustment.proto at 19:3
 */
CreditLimitAdjustment.Increase = $root.lookupType('squareup.corporate_card.resources.CreditLimitAdjustment.Increase');
fixType(CreditLimitAdjustment.Increase, {
  reason: {
    required: true
  },
  acceptanceType: {
    required: true
  }
});
Builder.createAndAttachToType(CreditLimitAdjustment.Increase);
/**
 * SOURCE IncreaseReason @ squareup/corporate_card/resources/credit_limit_adjustment.proto at 22:5
 */
CreditLimitAdjustment.Increase.IncreaseReason = $root.lookupEnum('squareup.corporate_card.resources.CreditLimitAdjustment.Increase.IncreaseReason').values;
/**
 * SOURCE AcceptanceType @ squareup/corporate_card/resources/credit_limit_adjustment.proto at 27:5
 */
CreditLimitAdjustment.Increase.AcceptanceType = $root.lookupEnum('squareup.corporate_card.resources.CreditLimitAdjustment.Increase.AcceptanceType').values;